import Typography, { TypographyProps } from "Components/Atoms/Typography";
import React, { useContext } from "react";
import "./styles.scss";
import { useHistory } from "react-router";
import { Modify } from "utils/types";
import { RestaurantContext } from "Contexts/RestaurantContext";

type LinkTo = {
  (rId: string): string;
};

export type ButtonProps = Modify<
  TypographyProps,
  {
    className?: string;
    linkTo?: LinkTo | string;
    href?: string;
    disabled?: boolean;
    target?: string;
  }
>;

const Button = ({
  linkTo,
  children,
  className = "",
  disabled = false,
  href,
  target,
  ...props
}: ButtonProps) => {
  const history = useHistory();

  const { restaurantId } = useContext(RestaurantContext);

  const path = linkTo
    ? typeof linkTo === "string"
      ? linkTo
      : linkTo(restaurantId || "")
    : null;

  // A real href makes the link reachable by keyboard and screen readers; the
  // click still navigates inside the app.
  const onClick = (event: React.MouseEvent) => {
    if (!path) return;
    event.preventDefault();
    if (!disabled) history?.push(path);
  };

  return (
    <Typography
      color={disabled ? "disabled" : "primary"}
      {...props}
      href={href ?? path ?? undefined}
      target={target}
      className={"link " + className}
      onClick={onClick}
    >
      {children}
    </Typography>
  );
};

export default Button;
